// extracted by mini-css-extract-plugin
export default {"ModalFooter":"n2riof49lEyCjueGxm2_","ModalCancelButton":"qLI7YRNFU3jI4EpYF2QY"};